import React from 'react';
import { CtaButton } from './CtaButton';
import { heroTestimonials, productImage } from '../data/content';
const badges = ['15 Volumes', '6 Bonuses', '208 Practice Weeks', '100+ Drills', 'All Age Groups', 'Instant Download'];
const stats = [{
  value: '500+',
  label: 'COACHES'
}, {
  value: '15+6',
  label: 'VOLUMES & BONUSES'
}, {
  value: '4.9/5',
  label: 'RATING ⭐'
}, {
  value: '🌎',
  label: 'USA & LATIN AMERICA'
}];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-line bg-ink" data-id="element-93" data-mp="xae8p3xwgomv">
      <div className="absolute inset-x-0 top-0 h-1 stitch-rule" aria-hidden="true" data-id="element-94" data-mp="x8b8jr319f4f" />

      {/* Above the fold on mobile: brand → headline → image → first CTA */}
      <div className="mx-auto flex min-h-[100svh] w-full max-w-6xl flex-col px-5 pb-6 pt-5 md:min-h-0 md:px-8 md:pb-16 md:pt-10" data-id="element-95" data-mp="nb6mrsd3nlo5">
        <div className="flex flex-col items-center gap-2 text-center md:gap-3" data-id="element-96" data-mp="3d2tm12xxw8bd">
          <span className="font-display text-base font-bold uppercase tracking-[0.2em] text-white md:text-xl" data-id="element-97" data-mp="380vy3velgpc3">
            ⚾ BASEBALL 360™
          </span>
          <span className="rounded-full border border-accent/40 bg-accent/10 px-3 py-1 text-[10px] font-semibold uppercase leading-tight tracking-[0.12em] text-accent md:px-4 md:py-1.5 md:text-xs" data-id="element-98" data-mp="3o7c4291259lw">
            ⚾ Trusted by coaches across the USA and Latin America
          </span>
        </div>

        <div className="mt-4 flex min-h-0 flex-1 flex-col items-center text-center md:mt-10 md:flex-none" data-id="element-99" data-mp="30iayctjm0ckb">
          <h1 className="max-w-4xl font-display text-[2.15rem] font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-7xl" data-id="element-100" data-mp="3599ik47pxusu">
            Plan your entire baseball season in under 5 minutes.
          </h1>
          <p className="mt-1.5 font-display text-lg font-bold uppercase tracking-wide text-accent sm:text-3xl md:mt-3" data-id="element-101" data-mp="2vjzoiitbe223">
            The Full-Season Practice Vault
          </p>
          <p className="mt-2.5 max-w-3xl text-[13px] leading-snug text-slate-300 md:mt-6 md:text-lg md:leading-relaxed" data-id="element-102" data-mp="2lla70r5byjmd">
            The definitive system for youth baseball coaches — 208 weeks of structured training,
            100+ drills, progressive curricula, and planning tools for every age group. Everything
            done for you.
          </p>

          <ul className="mt-2.5 flex flex-wrap justify-center gap-x-3 gap-y-1 md:mt-7 md:gap-x-5 md:gap-y-2" data-id="element-103" data-mp="ia5i8v83qdt4">
            {badges.map(badge => <li key={badge} className="text-[11px] font-medium text-slate-200 md:text-sm" data-id="element-104" data-mp="1b15ntam2zpmw">
                <span className="text-emerald-400" aria-hidden="true" data-id="element-105" data-mp="161b0fh1ili6l">
                  ✅
                </span>{' '}
                {badge}
              </li>)}
          </ul>

          <figure className="mt-3 flex min-h-0 w-full max-w-3xl flex-1 flex-col md:mt-10 md:flex-none" data-id="element-106" data-mp="x1ecjhmy8ncl">
            <img src={productImage} alt="Baseball 360 — The Complete Vault: annual coaching system box surrounded by the 6 bonus resource cards" className="h-full min-h-0 w-full object-contain md:h-auto md:max-h-[520px]" width={1080} height={1080} data-id="element-107" data-mp="3ltgndrclksov" />
            <figcaption className="mt-2 font-display text-xs font-bold uppercase tracking-wide text-slate-300 md:mt-3 md:text-lg md:text-slate-200" data-id="element-108" data-mp="21bpnpjwehz3b">
              Baseball 360 — The Complete Vault
            </figcaption>
          </figure>

          <div className="mt-3 w-full md:mt-9" data-id="element-109" data-mp="2b2k6ufecoikj">
            <CtaButton target="scroll" data-id="element-110" data-mp="2fyr8vx3ml9x7">🚀 I want Baseball 360 now</CtaButton>
            <p className="mt-2 text-[11px] text-slate-400 md:mt-3 md:text-sm" data-id="element-111" data-mp="2kydscoa1rmeg">
              🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-Day Guarantee
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-5 pb-14 md:px-8 md:pb-20" data-id="element-112" data-mp="2tztuy9umek84">
        <dl className="grid grid-cols-2 divide-line rounded-xl border border-line bg-ink-800 sm:grid-cols-4 sm:divide-x" data-id="element-113" data-mp="umhfcfyperqg">
          {stats.map(stat => <div key={stat.label} className="px-4 py-5 text-center" data-id="element-114" data-mp="zm2lbacak0co">
              <dt className="sr-only" data-id="element-115" data-mp="4akwoxpqsifg">{stat.label}</dt>
              <dd data-id="element-116" data-mp="4d7858fr7i2y">
                <span className="block font-display text-3xl font-extrabold text-white md:text-4xl" data-id="element-117" data-mp="3vhxglki0f9z2">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[11px] font-semibold tracking-[0.12em] text-slate-400" data-id="element-118" data-mp="e8setjvrp6j1">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-119" data-mp="3hnxu6k85oks5">
          {heroTestimonials.map(item => <blockquote key={item.name} className="flex h-full flex-col rounded-xl border border-line bg-ink-800 p-5" data-id="element-120" data-mp="3cpcsshh63v24">
              <p className="text-sm text-gold" aria-label="5 out of 5 stars" data-id="element-121" data-mp="3molll70ar3mw">
                ⭐⭐⭐⭐⭐
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-122" data-mp="2yxy5vzk539ps">“{item.quote}”</p>
              <footer className="mt-auto pt-4 text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-123" data-mp="2u0fxcaa1awib">
                {item.name} — {item.location}
              </footer>
            </blockquote>)}
        </div>
      </div>
    </header>;
}